<ng-container *ngIf="edit">
    <h2 mat-dialog-title>Editando Entrevista</h2>
</ng-container>
<ng-container *ngIf="!edit">
    <h2 mat-dialog-title>Cadastrar Entrevista</h2>
</ng-container>

<mat-dialog-content>
    <div class="interviews">
        <div class="interview-form">
            <form [formGroup]="formInterview">

                <div class="row">
                    <mat-form-field appearance="outline">
                      <mat-label>Processo Seletivo</mat-label>
                      <mat-select formControlName="processList" placeholder="Selecione um Processo">
                        <mat-option *ngFor="let process of processList" [value]="process.id">
                          {{ process.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  
                    <mat-form-field appearance="outline">
                        <mat-label>Nome da entrevista</mat-label>
                        <input matInput type="text" placeholder="Nome da entrevista" formControlName="name" />
                    </mat-form-field>
                </div>

                <div class="row">
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Data</mat-label>
                        <input matInput type="date" placeholder="Dia da entrevista" formControlName="dateStart" />
                        <mat-error *ngIf="formInterview.get('dateStart').errors?.minDate">A data da entrevista não pode ser anterior à data atual.</mat-error>
                    </mat-form-field>
                
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Horário inicial</mat-label>
                        <input matInput type="time" placeholder="Horário de inicio da entrevista" formControlName="timeStart" />
                        <mat-error *ngIf="formInterview.get('timeStart').errors?.beforeDate">O horário de início da entrevista deve ser anterior ao horário de término.</mat-error>
                        <mat-error *ngIf="formInterview.get('timeStart').errors?.invalidDate">Informe um horário válido</mat-error>
                    </mat-form-field>
                
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Horário final</mat-label>
                        <input matInput type="time" placeholder="Horário  final da entrevista" formControlName="timeEnd" />
                        <mat-error *ngIf="formInterview.get('timeEnd').errors?.afterDate">O horário de término da entrevista deve ser posterior ao horário de início.</mat-error>
                        <mat-error *ngIf="formInterview.get('timeEnd').errors?.invalidDate">Informe um horário válido</mat-error>
                    </mat-form-field>
                </div>

                <!--<div class="row">
                    <mat-slide-toggle color="primary" formControlName="nextDays">Extender para os próximos dias úteis, caso não for possivel agendar todos candidatos nesse dia e horário</mat-slide-toggle>
                </div>-->

                <div class="row" style="padding-bottom: 6px;">
                    <mat-form-field appearance="outline" class="hora">
                        <mat-label>Duração da entrevista</mat-label>
                        <input matInput type="time" min="0" placeholder="Duração da entrevista por candidato" formControlName="candidatesSessionDuration" />
                        <mat-hint>Em horas/minutos</mat-hint>
                    </mat-form-field>
                
                    <mat-form-field appearance="outline">
                        <mat-label>Contato da entrevista</mat-label>
                        <input matInput type="text" placeholder="Nome do contato para entrevista" formControlName="contact" />
                    </mat-form-field>
                </div>
                
                <p style="margin-left: 6px;">Tipo de Entrevista:</p>
                <div class="row align-center">
                    <span>Presencial</span>
                    <mat-slide-toggle 
                      color="primary" 
                      formControlName="type" 
                      (change)="onToggleChange($event)"
                      style="margin-top: -4px;">
                    </mat-slide-toggle>
                    <span>Remota</span>
                    <br>
                </div>

                <div *ngIf="!formInterview.get('type')?.value" class="address-field">
                    <!-- <div class="row">
                        <mat-form-field appearance="outline">
                            <mat-label>Endereço do local</mat-label>
                            <input matInput #autocomplete id="autocomplete" type="text" placeholder="Digite o Endereço do local de entrevista..." formControlName="address"/>
                        </mat-form-field>
                    </div> -->
                    <fieldset>
                        <legend>Endereço do local</legend>
                    
                        <div class="row">
                            <mat-form-field appearance="outline">
                                <mat-label>Numero</mat-label>
                                <input
                                matInput
                                type="text"
                                placeholder="Informe numero"
                                formControlName="number"
                                inputmode="numeric"
                                />
                            </mat-form-field>
                            <mat-form-field appearance="outline">
                                <mat-label>Cep</mat-label>
                                <input
                                    type="text"
                                    matInput
                                    placeholder="Informe o cep"
                                    formControlName="zipCode"
                                    mask="00000-000"
                                    inputmode="numeric"
                                />
                            </mat-form-field>
                        </div>    
                    
                        <div class="row">
                          <mat-form-field appearance="outline">
                            <mat-label>Endereço</mat-label>
                            <input
                              matInput
                              type="text"
                              placeholder="Informe o Endereço do local de entrevista"
                              formControlName="address"
                            />
                          </mat-form-field>
                        </div>
                    </fieldset>
                </div>

            </form>
        </div>            
    </div>
</mat-dialog-content>

<mat-progress-bar color="primary" mode="indeterminate" *ngIf="submiting"></mat-progress-bar>

<mat-dialog-actions *ngIf="!submiting">
    <button color="accent" mat-dialog-close mat-button>Fechar</button>
    <div class="actions" [hidden]="submiting">
        <ng-container *ngIf="edit">
            <button mat-raised-button color="primary" (click)="submitInterview()" type="submit">Atualizar</button>
        </ng-container>
        <ng-container *ngIf="!edit">
            <button mat-raised-button color="primary" (click)="submitInterview()" type="submit">Salvar</button>
        </ng-container>        
    </div>
</mat-dialog-actions>